/* eslint-disable no-new */
import Vue from 'vue/dist/vue.esm';

[...document.querySelectorAll('blockquote')].forEach(el => {
  const quotes = el.querySelectorAll('p, h2, h3, h4, h5, h6, pre');

  new Vue({
    el,
    methods: {
      setQuotes() {
        quotes.forEach(item => {
          const span = document.createElement('span');
          span.classList.add('quote-inner');
          span.innerHTML = item.innerHTML;
          item.innerHTML = ''; // eslint-disable-line no-param-reassign
          item.appendChild(span);
        });
      },
    },
    created() {
      this.setQuotes();
    },
  });
});
